import { useAuth0 } from '@auth0/auth0-react';
import Button from '@mui/material/Button';
import { cleanupUserData } from '../../services';

const LogoutButton = () => {
    const { logout } = useAuth0();

    const handleLogout = () => {
        cleanupUserData();
        logout({ logoutParams: { returnTo: window.location.origin } });
    };

    return (
        <Button color="inherit" variant="outlined" onClick={handleLogout}>
            Log Out
        </Button>
    );
};

export default LogoutButton;
